import dayjs from "dayjs";
import { jwtDecode } from "jwt-decode";

export const getUserRoles = () => {
  let token = localStorage.getItem("accessToken");
  if (token) {
    let decoded = jwtDecode(token);
    return {
      user: decoded.given_name,
      id: decoded.nameid,
      roles: decoded.roles ? JSON.parse(decoded.roles) : [],
    };
  }
  return { user: "", roles: [], id: null };
};

export const isTokenExpired = () => {
  let token = localStorage.getItem("accessToken");
  if (!token) return true;
  let decoded = jwtDecode(token);
  return dayjs().isAfter(dayjs(decoded.exp * 1000));
};
